import { render } from "./pmode-legend.vue?vue&type=template&id=5ff17c25"
import script from "./pmode-legend.vue?vue&type=script&lang=js"
export * from "./pmode-legend.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__